<template>
  <div class="container">
    <div class="secondContainer">
    <div class="top-section">
      <div class="my-name name-loc">
        Joshua Lee Glass
      </div>
      <div class="my-name small">
        <!-- eslint-disable-next-line -->
        {{"<\AboutMe />"}}
      </div>
    </div>
    <div class="about-me-container box">
      <p>Welcome to my resume site!</p>
      <p>Currently, I am a Software Engineer for <a href="http://agiftinside.com">A Gift Inside</a>. I live in the Sacramento area with
      my wife and my little boy, plus two annoying dogs! In my spare time, you can find me
      advancing my technology and programming knowledge, or snowboarding the awesome
      mountains in Tahoe. At this time, my career goals are to become one of the best
      System Engineers / Software Engineer in the industry specializing in automation</p>
      <p>When I am not training to be a coding ninja, I dabble on the server side to stay up-
      to-date with tech like <a href="https://docs.chef.io/">Chef</a>. Also, I am a huge Raspberry PI and microcomputer
      enthusiast. I have made several remarkable little robots and large-scale services.</p>
    </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
export default {
  name: 'HelloWorld',
  components: {
    AppHeader
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only

position: absolute;
top: 41%;
text-align: center;
left: 15%;
 -->
<style scoped>
   .container {
     text-align: center;
     align-items: center;
     display: flex;
     justify-content: center;
   }
   .secondContainer {
     max-width: 700px;
   }
  .about-me-container {
    padding: 10px;

    margin: 0 auto;
  }
  .my-name {
    letter-spacing: .1rem;
    font-weight: 100;
    font-size: 50px;
    color: white;
  }
  .small {
    color: red;
    font-size: 29px !important;
    font-weight: 100;
    padding-bottom: 300px;
  }
  a {
    color: #fe8854;
    font-weight: 500;
    text-decoration: none !important;
  }
  .top-section{
    max-height: 150px;
  }
  .name-loc {

  }
  .box {
    background-color: salmon;
    height: auto;
    border-radius: 8px;
    background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
    box-shadow: 0 15px 20px rgba(0,0,0,0.19), 0 7px 6px rgba(0,0,0,0.23);
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue